import * as React from 'react'
import Card from '@mui/material/Card'

interface Props {
  children: React.ReactNode
}

const TopBorderCard = ({children}: Props) => (
  <Card
    elevation={0}
    sx={{
      borderTopRightRadius: 0,
      borderTopLeftRadius: 0,
      position: 'relative',
      background: '#ECF2F6',
      '&::after': {
        content: '""',
        position: 'absolute',
        top: 0,
        height: '5px',
        width: '100%',
        background: theme =>
          `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.primary.light})`,
      },
    }}
  >
    {children}
  </Card>
)

export default TopBorderCard
